/**
 * Pricing constants — single source of truth for the public-facing price.
 *
 * Whenever a UI surface needs to display a price BEFORE the live
 * `/api/payments/price` call has resolved (or if it fails), it should
 * fall back to these defaults rather than hardcoding a number inline.
 *
 * To change the listed price, update this file ONLY. The backend
 * (`backend/routes/payments.py` → `PRICING_TIERS`) is the
 * server-side source of truth and overrides whatever the client falls
 * back to once the API responds.
 */

export const DEFAULT_PRICE_USD = 97;
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_IS_FOUNDER = false;

/** Pre-shaped object matching the response from GET /api/payments/price. */
export const DEFAULT_PRICE_OBJECT = {
  amount: DEFAULT_PRICE_USD,
  currency: DEFAULT_CURRENCY,
  is_founder: DEFAULT_IS_FOUNDER,
};
